import { IntlShape } from 'react-intl'
import { ICurrency } from '../../api/types'
import { DEFAULT_BASE_CURRENCY } from '../DonationForm/constants'

export const getCurrencySign = (intl: IntlShape, currencyCode?: string) => {
  if (!currencyCode) {
    return ''
  }

  try {
    const sign = intl
      .formatNumberToParts(0, { style: 'currency', currency: currencyCode })
      .find(x => x.type === 'currency')?.value

    return sign
  } catch (e) {
    // error
  }

  return ''
}

export const getCurrentBaseCurrencyOption = (baseCurrencies: ICurrency[], baseCurrencyCode?: string) => {
  const baseCurrencyOption = baseCurrencies.find(currency => currency.code === baseCurrencyCode)

  let option

  if (baseCurrencyOption) {
    option = baseCurrencyOption
  } else if (baseCurrencyCode) {
    option = baseCurrencies.find(currency => currency.code === baseCurrencyCode)
  }

  if (!option) {
    option = baseCurrencies.find(currency => currency.code === DEFAULT_BASE_CURRENCY) ?? baseCurrencies[0]
  }

  return option
}
